// components
import maAdminView from '../adminView'
import maFilters from '../../components/filters'
import maPaginator from '@/components/paginator'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputSelect from '@/components/input/modules/select'
import maEmpty from '@/components/empty'

// utils
import debounce from '@/utils/debounce'

// api
import {
  apiGetAdminSalaries,
  apiPatchAdminSalaries,
  apiDeleteAdminSalaries
} from '@/services/API/adminGag'

export default {
  name: 'salaries',
  data: function () {
    return {
      salaries: {
        dept_code: null,
        csp: null,
        salary_hour: null
      },
      deptCodeFilterText: '',
      filterTableByDeptCodeDebounced: debounce(this.filterTableByDeptCode, 200)
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputSelect,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminSalaries(this.currentPage, this.deptCodeFilterText)
        .then(salaries => {
          this.table = salaries.results
          this.totalPages = salaries.total_pages || 0
        })
    },
    handleEdit: function (data) {
      this.salaries = data
      this.$refs.adminGagEditModal.showModal = true
    },
    handleDelete: function (data) {
      apiDeleteAdminSalaries(data).then(() => {
        this.handleSearch()
        this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
      })
    },
    handleSave: function () {
      apiPatchAdminSalaries(this.salaries)
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminGagEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    },
    filterTableByDeptCode (zipCodeFilter) {
      this.deptCodeFilterText = zipCodeFilter
      this.handleSearch()
    },
    resetEditValues: function () {
      if (this.salaries) {
        Object.keys(this.salaries).forEach(item => (item = null))
      }
    }
  }
}
